<script setup lang="ts">
import SvgIcon from '@jamescoyle/vue-icon'

withDefaults(
  defineProps<{
    path: string
    size?: string | number
    color?: string
    /**
     * The viewBox of the SVG element
     */
    viewBox?: string
    /**
     * One of "horizontal", "vertical", or "both". Flips the icon in the specified direction(s).
     */
    flip?: string
    /**
     * Rotates the icon by the specified value. Can be any valid CSS angle value.
     */
    rotate?: string
  }>(),
  {
    size: 24,
    color: 'currentColor',
    viewBox: '0 0 24 24',
    flip: undefined,
    rotate: undefined,
  }
)
</script>

<template>
  <span
    :style="{ color }"
    class="mdi-icon inline-flex leading-0 text-current"
  >
    <svg-icon
      type="mdi"
      :path="path"
      :size="size"
      :viewbox="viewBox"
      :flip="flip"
      :rotate="rotate"
    />
  </span>
</template>

<style scoped>
.mdi-icon svg {
  display: block;
}
.mdi-icon svg {
  fill: currentColor;
}
</style>
